/**
 * Base directive class shared by the concrete ScrollReveal directives.
 */
export var AbstractNgsRevealDirective = (function () {
    function AbstractNgsRevealDirective(ngsRevealService) {
        this.ngsRevealService = ngsRevealService;
    }
    AbstractNgsRevealDirective.prototype._initConfig = function (value) {
        if (value && typeof value === 'string') {
            this.config = JSON.parse(value);
        }
        else if (value && typeof value === 'object') {
            this.config = value;
        }
    };
    return AbstractNgsRevealDirective;
}());
//# sourceMappingURL=ngs-reveal-common.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ng-scrollreveal/directives/ngs-reveal-common.directive.js
// module id = ./node_modules/ng-scrollreveal/directives/ngs-reveal-common.directive.js
// module chunks = vendor